export default __webpack_public_path__ + "media/images/pp_logo_name_xl-8e6a3c9385f64b20e13e7f5dd00acdd0.png";